module.exports = __webpack_public_path__ + "static/media/rafík.54e258d7.svg";